module.exports = __webpack_public_path__ + "img/justine.a274ec40.png";